import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  kycOptions: {
    streetAddressOne: '',
    streetAddressTwo: '',
    state: '',
    postalCode: '',
  },
  kycOptions_new: {
    savings_account_consent: false,
    first_name: '',
    last_name: '',
    personal_email: '',
    mobile: '',
    phone_country: '',
    same_as_mailing: false,
    birthDateMoment: null,
    birth_date: '',
    id_number_new: '',
    address_1: '',
    address_2: '',
    city: '',
    postal_code: '',
    country_code: 'US',
  },
  kybOptions: {
    ein: '',
    legal_business_name: '', // Required
    dba_business_name: '',
    business_type: '',
    date_established: '', // YYYY-MM-DD
    dateEstablishedMoment: null,
    phone: '',
    phone_country: '',
    email: '',
    website: '',
    first_name: '',
    last_name: '',

    is_controller: null,
    controller_first_name: '',
    controller_last_name: '',
    controller_dob: '',
    controller_ssn: '',
    account_email: '',
    controllerDOBMoment: null,

    is_authorized_admin: false,
    agreements_consent: false,
  },
  kybOptions_new: {
    ein: '',
    legal_business_name: '', // Required
    dba_business_name: '',
    business_type: '',
    date_established: '', // YYYY-MM-DD
    dateEstablishedMoment: null,
    phone: '',
    phone_country: '',
    email: '',
    website: '',
    first_name: '',
    last_name: '',

    is_controller: null,
    controller_first_name: '',
    controller_last_name: '',
    controller_dob: '',
    controller_ssn: '',
    account_email: '',
    controllerDOBMoment: null,

    is_authorized_admin: false,
    agreements_consent: false,
  },
  kybView: null,
  onboardingOptions: {},
  beneficialOwnerOptions: {},
}

const kyxSlice = createSlice({
  name: 'kyx',
  initialState,
  reducers: {
    setKYBOptions: (state, action) => {
      state.kybOptions = { ...state.kybOptions, ...action.payload }
    },
    clearKYBOptions: state => {
      state.kybOptions = initialState.kybOptions
    },
    setKYCOptions: (state, action) => {
      state.kycOptions = { ...state.kycOptions, ...action.payload }
    },
    clearKYCOptions: state => {
      state.kycOptions = initialState.kycOptions
    },
    setNewKYCOptions: (state, action) => {
      state.kycOptions_new = { ...state.kycOptions_new, ...action.payload }
    },
    clearNewKYCOptions: state => {
      state.kycOptions_new = initialState.kycOptions_new
    },
    setNewKYBOptions: (state, action) => {
      state.kybOptions_new = { ...state.kybOptions_new, ...action.payload }
    },
    clearNewKYBOptions: state => {
      state.kybOptions_new = initialState.kybOptions_new
    },
    setKYBView: (state, action) => {
      state.kybView = action.payload
    },
    setOnboardingOptions: (state, action) => {
      state.onboardingOptions = { ...state.onboardingOptions, ...action.payload }
    },
    clearOnboardingOptions: state => {
      state.onboardingOptions = initialState.onboardingOptions
    },
    setBeneficialOwnerOptions: (state, action) => {
      state.beneficialOwnerOptions = { ...state.beneficialOwnerOptions, ...action.payload }
    },
    clearBeneficialOwnerOptions: state => {
      state.beneficialOwnerOptions = initialState.beneficialOwnerOptions
    },
  },
})

export const {
  setKYBOptions,
  clearKYBOptions,
  setKYCOptions,
  clearKYCOptions,
  setNewKYCOptions,
  clearNewKYCOptions,
  setNewKYBOptions,
  clearNewKYBOptions,
  setKYBView,
  setOnboardingOptions,
  clearOnboardingOptions,
  setBeneficialOwnerOptions,
  clearBeneficialOwnerOptions,
} = kyxSlice.actions

export default kyxSlice.reducer
